<template>
  <div class="public-shop member-auth-page">
    <header class="shop-header member-auth-hero" :style="{ background: themeGradient }">
      <div class="container member-auth-hero-inner">
        <router-link :to="shopPath('/member/login')" class="member-auth-back">
          <i class="fas fa-arrow-left"></i> Kembali ke Login
        </router-link>
        <div class="member-auth-brand" v-if="shop">
          <img v-if="shop.logo_url" :src="shop.logo_url" alt="" class="member-auth-logo">
          <div v-else class="member-auth-logo-placeholder">
            <i class="fas fa-store"></i>
          </div>
          <div>
            <h1 class="member-auth-shop-name text-white">{{ shop.name }}</h1>
            <small class="text-white-50">Reset Password</small>
          </div>
        </div>
      </div>
    </header>

    <div class="container member-auth-wrap">
      <div class="row justify-content-center">
        <div class="col-md-5 col-lg-4">
          <div class="member-auth-card shop-card p-4 p-md-5">
            <div class="member-auth-card-header mb-4">
              <div class="member-auth-icon-wrap">
                <i class="fas fa-key"></i>
              </div>
              <h2 class="member-auth-title">Lupa Password</h2>
              <p class="member-auth-subtitle">Masukkan email yang digunakan saat order. Kami akan kirim link reset ke email Anda.</p>
            </div>

            <div v-if="success" class="member-alert member-alert-success">
              <i class="fas fa-check-circle"></i>
              <span>{{ success }}</span>
            </div>
            <div v-if="error" class="member-alert member-alert-danger">
              <i class="fas fa-exclamation-circle"></i>
              <span>{{ error }}</span>
            </div>

            <form v-if="!success" @submit.prevent="submit">
              <div class="member-form-group">
                <label class="member-form-label">Email</label>
                <input
                  v-model="email"
                  type="email"
                  class="member-form-input"
                  placeholder="email@example.com"
                  required
                  :disabled="loading"
                >
              </div>
              <button type="submit" class="member-btn-primary" :disabled="loading">
                <span v-if="loading"><i class="fas fa-spinner fa-spin"></i> Mengirim...</span>
                <span v-else><i class="fas fa-paper-plane mr-1"></i> Kirim Link Reset</span>
              </button>
            </form>

            <div v-if="success" class="member-footer-link">
              <router-link :to="shopPath('/member/login')" class="member-link">
                <i class="fas fa-arrow-left mr-1"></i> Kembali ke Login
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import publicShopPaths from './public_shop_paths';
import { applyShopTheme, shopHeaderBackground, shopPublicMixin } from '@/components/shop_public/shop_public_utils';
import '@/components/shop_public/shop_public.css';
import '@/components/shop_public/member_portal.css';

export default {
  mixins: [publicShopPaths, shopPublicMixin],
  data() {
    return {
      shop: null,
      email: '',
      loading: false,
      error: '',
      success: '',
    };
  },
  computed: {
    themeGradient() {
      return shopHeaderBackground(this.shop);
    },
  },
  async mounted() {
    if (this.onCustomDomain) {
      await this.$store.dispatch('public_shop/public_get_shop_by_domain');
    }
    const r = await this.$store.dispatch('public_shop/public_get_shop', this.effectiveSlug);
    this.shop = r.data.data.shop;
    applyShopTheme(this.shop);
  },
  methods: {
    async submit() {
      this.loading = true;
      this.error = '';
      try {
        const r = await this.$store.dispatch('public_shop/member_forgot_password', {
          slug: this.effectiveSlug,
          email: this.email,
        });
        this.success = r.data.message || 'Link reset password telah dikirim ke email Anda.';
      } catch (e) {
        this.error = e.response?.data?.message || 'Gagal mengirim permintaan reset.';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
